import { date, startOfDay } from './time.ts';

/** [start of `from`, start of the day after `to`) in the zone, as epoch ms: whole days, `to` included. */
export function dayRange(from: string, to: string, timeZone: string): { start: number; end: number } {
  return {
    start: startOfDay(date(from), timeZone),
    end: startOfDay(date(to).add({ days: 1 }), timeZone),
  };
}
